import React from 'react';
import { Box, Typography } from '@mui/material';

const MESRequiredTag: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 0.5,
        ml: 2, // 16px gap from title
        borderRadius: '8px',
        border: "1px solid #2667B0",
        background: "linear-gradient(90deg, rgba(38, 103, 176, 0.30) 0%, rgba(16, 43, 74, 0.30) 100%)",
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          color: '#102B4A',
          letterSpacing: '-0.12px',
          fontFamily: 'Poppins, sans-serif',
          lineHeight: '20px',
          whiteSpace: 'nowrap',
        }}
      >
        MES Mandatory
      </Typography>
    </Box>
  );
};

export default MESRequiredTag;